// src/components/common/MaintenanceBanner/MaintenanceBanner.html.tsx

import * as React from 'react';

interface IMaintenanceBannerHtmlProps {
  classes: Record<string, string>;
  state: 'scheduled' | 'incident' | 'resolved';
  formattedTime: string;
  estimatedDuration: string;
  message?: string;
  onDismiss: () => void;
}

const bannerClassMap = {
  scheduled: 'banner',
  incident: 'bannerIncident',
  resolved: 'bannerResolved',
};

const iconMap = {
  scheduled: '⚠️',
  incident: '🔴',
  resolved: '✅',
};

const textClassMap = {
  scheduled: 'text',
  incident: 'textIncident',
  resolved: 'textResolved',
};

export const MaintenanceBannerHtml = ({
  classes,
  state,
  formattedTime,
  estimatedDuration,
  message,
  onDismiss,
}: IMaintenanceBannerHtmlProps) => (
  <div className={classes[bannerClassMap[state]]}>
    <div className={classes.content}>
      <span className={classes[state === 'scheduled' ? 'warningIcon' : 'incidentIcon']}>
        {iconMap[state]}
      </span>
      <span className={classes[textClassMap[state]]}>
        {state === 'scheduled' && (
          <>
            <span className={classes.bold}>Upcoming Maintenance: </span>
            The app will be unavailable on{' '}
            <span className={classes.bold}>{formattedTime}</span>
            {estimatedDuration ? ` for ${estimatedDuration}` : ''}.
          </>
        )}
        {state === 'incident' && (
          message || "We're aware of an issue and our team is actively looking into it."
        )}
        {state === 'resolved' && (
          message || 'The issue has been resolved. Everything is back to normal.'
        )}
      </span>
    </div>
    <button className={classes.dismissButton} onClick={onDismiss}>
      &#10005;
    </button>
  </div>
);
